import(/* webpackMode: "eager", webpackExports: ["Badge"] */ "/vercel/path0/node_modules/@mantine/core/esm/components/Badge/Badge.mjs");
;
import(/* webpackMode: "eager", webpackExports: ["Container"] */ "/vercel/path0/node_modules/@mantine/core/esm/components/Container/Container.mjs");
;
import(/* webpackMode: "eager", webpackExports: ["Image"] */ "/vercel/path0/node_modules/@mantine/core/esm/components/Image/Image.mjs");
;
import(/* webpackMode: "eager", webpackExports: ["Space"] */ "/vercel/path0/node_modules/@mantine/core/esm/components/Space/Space.mjs");
;
import(/* webpackMode: "eager", webpackExports: ["__esModule","default"] */ "/vercel/path0/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next/dist/client/script.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/app/[lang]/articles/articles.module.scss");
;
import(/* webpackMode: "eager", webpackExports: ["EditionModale"] */ "/vercel/path0/src/components/EditionModale/EditionModale.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/components/Error/Error404.tsx");
